import Cookies from 'js-cookie'

const TOKEN_KEY = 'admin_token'
const USER_INFO_KEY = 'admin_user_info'

/**
 * 获取Token
 */
export function getToken() {
  return Cookies.get(TOKEN_KEY)
}

/**
 * 设置Token
 */
export function setToken(token) {
  return Cookies.set(TOKEN_KEY, token, { expires: 7 })
}

/**
 * 移除Token
 */
export function removeToken() {
  return Cookies.remove(TOKEN_KEY)
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  const userInfo = localStorage.getItem(USER_INFO_KEY)
  return userInfo ? JSON.parse(userInfo) : null
}

/**
 * 设置用户信息
 */
export function setUserInfo(userInfo) {
  return localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

/**
 * 移除用户信息
 */
export function removeUserInfo() {
  return localStorage.removeItem(USER_INFO_KEY)
}